import React from 'react';
import { Handle, Position } from 'react-flow-renderer';



function TextUpdaterNode({ data, isConnectable }) {

    return (
        <div className="task-node">
            <Handle type="target" position={Position.Top} isConnectable={isConnectable} />
               {data.label}
            <Handle
                type="source"
                position={Position.Bottom}
                id="a"
                isConnectable={isConnectable}
            />
        </div>
    );



}


export default TextUpdaterNode;